'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SwapHoriz = require('material-ui-icons/SwapHoriz');

var _SwapHoriz2 = _interopRequireDefault(_SwapHoriz);

var _Select = require('material-ui/Select');

var _Select2 = _interopRequireDefault(_Select);

var _FormControl = require('material-ui/Form/FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _InputLabel = require('material-ui/Input/InputLabel');

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _MenuItem = require('material-ui/Menu/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _ = require('../../..');

var _2 = _interopRequireDefault(_);

var _Connector = require('../Connector');

var _Viewer = require('../Viewer');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // export const ConnectorContext = createContext({});


var ObjectConnector = (_temp = _class = function (_EditorComponent) {
  _inherits(ObjectConnector, _EditorComponent);

  function ObjectConnector() {
    _classCallCheck(this, ObjectConnector);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  } // canBeDropped(dragItem) {
  //   return dragItem && dragItem instanceof ConnectorView ? true : false;
  // }


  ObjectConnector.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_SwapHoriz2.default, null), ' Object Connector'));
  };

  ObjectConnector.prototype.prepareRootElementProps = function prepareRootElementProps(props) {
    var _EditorComponent$prot = _EditorComponent.prototype.prepareRootElementProps.call(this, props),
        fetchPolicy = _EditorComponent$prot.fetchPolicy,
        other = _objectWithoutProperties(_EditorComponent$prot, ['fetchPolicy']);

    return other;
  };

  ObjectConnector.prototype.prepareDragItemProps = function prepareDragItemProps() {
    return _extends({}, _EditorComponent.prototype.prepareDragItemProps.call(this), {
      filtersname: "filters",
      where: {}
    });
  };

  ObjectConnector.prototype.prepareDragItemComponents = function prepareDragItemComponents() {
    return _EditorComponent.prototype.prepareDragItemComponents.call(this).concat([{
      "name": "Filters",
      "component": "Filters",
      props: {},
      "components": []
    }, {
      "name": "ObjectView",
      "component": "ObjectView",
      props: {},
      "components": []
    }]);
  };

  ObjectConnector.prototype.getEditorField = function getEditorField(props) {
    var _this2 = this;

    var key = props.key,
        type = props.type,
        name = props.name,
        value = props.value,
        other = _objectWithoutProperties(props, ['key', 'type', 'name', 'value']);

    var query = this.context.query;
    var activeItem = this.getActiveItem();
    var queryNames = Object.keys(query);
    var field = void 0;

    if (!field) {
      switch (name) {
        case "query":
          field = _react2.default.createElement(_FormControl2.default, {
            key: key,
            fullWidth: true
          }, _react2.default.createElement(_InputLabel2.default, null, 'Query name'), _react2.default.createElement(_Select2.default, {
            value: value,
            onChange: function onChange(event) {
              return _this2.onChangeProps(event);
            },
            inputProps: {
              name: name // id: 'age-simple',

            }
          }, queryNames.filter(function (n) {
            return n.endsWith && !n.endsWith("Connection");
          }).map(function (queryName) {
            return _react2.default.createElement(_MenuItem2.default, {
              key: queryName,
              value: queryName
            }, queryName);
          })));
          break;
        // case "skip":
        // case "last":
        //   type = "number";
        //   break;
      }
    }

    if (!field) {
      if (activeItem) {
        var _activeItem$getObject = activeItem.getObjectWithMutations(),
            fieldName = _activeItem$getObject.props.query;

        if (fieldName) {
          var Field = this.getSchemaField(fieldName);

          if (Field) {
            var args = Field.args;
            var arg = args ? args.find(function (n) {
              return n.name === name;
            }) : null;

            if (arg) {
              var _arg$type = arg.type,
                  typeKind = _arg$type.kind,
                  typeName = _arg$type.name;

              switch (typeKind) {
                case "ENUM":
                  var Type = this.getSchemaType(function (n) {
                    return n.name === typeName && n.kind === typeKind;
                  });

                  if (Type) {
                    var enumValues = Type.enumValues;
                    field = _react2.default.createElement(_FormControl2.default, {
                      key: key,
                      fullWidth: true
                    }, _react2.default.createElement(_InputLabel2.default, null, name), _react2.default.createElement(_Select2.default, {
                      value: value || "",
                      onChange: function onChange(event) {
                        return _this2.onChangeProps(event);
                      },
                      inputProps: {
                        name: name // id: 'age-simple',

                      }
                    }, enumValues.map(function (n) {
                      var fieldName = n.name;
                      return _react2.default.createElement(_MenuItem2.default, {
                        key: fieldName,
                        value: fieldName
                      }, fieldName);
                    })));
                  }

                  break;

                case "SCALAR":
                  switch (typeName) {
                    case "Int":
                    case "Float":
                      type = "number";
                      break;
                  }

                  break;
              }
            }
          }
        }
      }
    }

    Object.assign(props, {
      type: type,
      name: name,
      value: value
    });
    return field !== undefined ? field : _EditorComponent.prototype.getEditorField.call(this, props);
  };

  ObjectConnector.prototype.updateComponentProperty = function updateComponentProperty(name, value) {
    var _extends2;

    var activeItem = this;
    var newProps = {};

    var _activeItem$getObject2 = activeItem.getObjectWithMutations(),
        props = _activeItem$getObject2.props;

    switch (name) {
      case "query":
        {
          var Field = this.getSchemaField(value);

          if (Field) {
            var args = Field.args;
            args.map(function (n) {
              var argName = n.name,
                  defaultValue = n.defaultValue,
                  _n$type = n.type,
                  typeKind = _n$type.kind,
                  typeName = _n$type.name,
                  ofType = _n$type.ofType;
              var propName = void 0;
              var propValue = void 0;

              switch (typeKind) {
                case "SCALAR":
                  switch (typeName) {
                    case "Int":
                    case "Float":
                      propName = argName;
                      propValue = props[argName] !== undefined ? props[argName] : defaultValue ? parseFloat(defaultValue) : defaultValue;
                      break;

                    case "String":
                      break;
                  }

                  break;

                case "ENUM":
                  propName = argName;
                  propValue = defaultValue;
                  break;
              }

              if (propName) {
                var _Object$assign;

                Object.assign(newProps, (_Object$assign = {}, _Object$assign[propName] = propValue, _Object$assign));
              }
            });
          } else {
            return false;
          }
        }
        return activeItem.updateComponentProps(_extends({}, newProps, (_extends2 = {}, _extends2[name] = value, _extends2)));
        break;
    }

    return _EditorComponent.prototype.updateComponentProperty.call(this, name, value);
  };

  ObjectConnector.prototype.getSchemaField = function getSchemaField(fieldName) {
    var schema = this.context.schema;
    var queryTypeName = schema.queryType.name,
        types = schema.types;
    var query = schema.types.find(function (n) {
      return n.kind === "OBJECT" && n.name === queryTypeName;
    });
    var Field = query.fields.find(function (n) {
      return n.name === fieldName;
    });
    return Field;
  };

  ObjectConnector.prototype.getSchemaType = function getSchemaType(filter) {
    var schema = this.context.schema;
    var types = schema.types;
    var Field = types.find(filter);
    return Field;
  };

  ObjectConnector.prototype.getFilters = function getFilters() {
    var _getComponentProps = this.getComponentProps(this),
        filters = _getComponentProps.where;

    return filters;
  };

  ObjectConnector.prototype.setFilters = function setFilters(filters) {
    // activeItem.updateComponentProperty("where", filters)
    // this.updateComponentProperty("test", "filters")
    // return this.updateActiveComponentProps(this, {
    //   where: filters,
    // });
    return this.updateComponentProps({
      where: filters
    });
  };

  ObjectConnector.prototype.canBeChild = function canBeChild(child) {
    var can = false;

    if (_EditorComponent.prototype.canBeChild.call(this, child)) {
      var _getComponentProps2 = this.getComponentProps(this),
          componentProps = _getComponentProps2.props;

      var _ref = componentProps || {},
          query = _ref.query;

      var parentQuery = void 0;
      var parent = this.props.parent;

      if (parent) {
        // const {
        //   query,
        // } = parent.props.data.object.props;
        var _parent$getObjectWith = parent.getObjectWithMutations(),
            _query = _parent$getObjectWith.props.query;

        if (_query) {
          parentQuery = _query;
        }
      }

      if (query || parentQuery) {
        can = true;
      }
    }

    return can;
  };

  ObjectConnector.prototype.renderChildren = function renderChildren() {
    var _this3 = this;

    var schema = this.context.schema;
    /**
     * schema required for viewer
     */

    if (!schema) {
      return null;
    }

    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;

    var offsetParent = this.props.parent;

    var _getRenderProps = this.getRenderProps(),
        _getRenderProps$props = _getRenderProps.props,
        orderBy = _getRenderProps$props.orderBy,
        query = _getRenderProps$props.query,
        otherProps = _objectWithoutProperties(_getRenderProps$props, ['orderBy', 'query']),
        propsWhere = _getRenderProps.where,
        parent = _getRenderProps.parent,
        other = _objectWithoutProperties(_getRenderProps, ['props', 'where', 'parent']);
    /**
     * Если есть родитель и у родителя имеется свойство query, то используем его
     */


    var parentQuery = void 0;

    if (offsetParent) {
      // const {
      //   query,
      // } = offsetParent.props.data.object.props;
      var _offsetParent$getObje = offsetParent.getObjectWithMutations(),
          _query2 = _offsetParent$getObje.props.query;

      if (_query2) {
        parentQuery = _query2;
      }
    }

    if (!query && !parentQuery) {
      return inEditMode ? _react2.default.createElement(_Typography2.default, {
        color: 'error'
      }, 'Query props required') : null;
    } // const {
    // } = this.getComponentProps(this);


    var filters = this.getFilters();
    var where = filters;

    if (!where || !Object.keys(where).length) {
      /**
       * Если элемент находится в роутере, пытаемся получить параметры из УРЛ.
       * Так как у нас добавился еще объект Query, который может возникнуть между 
       * коннектором и роутером. то роутинг смотрим и в прародителе
       */
      // let matchParams;
      if (parent) {
        var _parent$props = parent.props,
            match = _parent$props.match,
            grandParent = _parent$props.parent;

        var _ref2 = match || {},
            params = _ref2.params;

        if (params) {
          where = params;
        } else if (grandParent) {
          var _match = grandParent.props.match;

          var _ref3 = _match || {},
              _params = _ref3.params;

          if (_params) {
            where = {};
            /**
             * Получаем только те значения, у которых ключ - строка.
             */

            Object.keys(_params).map(function (key) {
              if (key && typeof key === "string" && isNaN(parseInt(key))) {
                where[key] = _params[key];
              }
            });
          }
        }
      }
    }

    return _react2.default.createElement(_Viewer.ObjectView, _extends({}, otherProps, this.getComponentProps(this), {
      key: query,
      query: query,
      parentQuery: parentQuery,
      setFilters: function setFilters(filters) {
        return _this3.setFilters(filters);
      },
      filters: filters || [],
      where: where,
      ConnectorContext: _Connector.ConnectorContext
    }), _EditorComponent.prototype.renderChildren.call(this));
  };

  return ObjectConnector;
}(_2.default), _class.Name = "ObjectConnector", _class.help_url = "https://front-editor.prisma-cms.com/topics/query.html", _class.defaultProps = _extends({}, _2.default.defaultProps, {
  query: "",
  // pagevariable: "page",
  filtersname: "filters",
  // first: 10,
  hide_wrapper_in_default_mode: true,
  // https://www.apollographql.com/docs/react/api/react-apollo/#optionsfetchpolicy
  fetchPolicy: undefined
}), _temp);
exports.default = ObjectConnector;
module.exports = exports['default'];